import {
  getData
} from '@/cllib/local_storage'

import {
  groupGetCarteams
} from '@/api/api'

const state = {
  userInfo: {},
  availableMenus: [],
  availableGroupsCarteams: [],
  userDriverList: []
}

const getters = {
  userInfo: state => state.userInfo,
  canEditData: (state) => {
    // let data = false
    // let roles = state.userInfo.roles || []
    // roles.forEach((item) => {
    //   if (item.name === 'dataAdmin') {
    //     data = true
    //   }
    // })
    // return data
    return true
  },
  userDriverList: state => state.userDriverList,
  availableMenus: state => state.availableMenus,
  currentPrevilege: state => state.userInfo.currentPrevilege,
  currentGroupId: state => state.userInfo.currentPrevilege && state.userInfo.currentPrevilege.paramName === 'groupId' ? state.userInfo.currentPrevilege.id : null,
  currentCarTeamId: state => state.userInfo.currentPrevilege && state.userInfo.currentPrevilege.paramName === 'carGroupId' ? state.userInfo.currentPrevilege.id : null,
  currentCompanyId: state => state.userInfo.currentPrevilege && state.userInfo.currentPrevilege.paramName === 'companyId' ? state.userInfo.currentPrevilege.id : null,
  currentRole: state => state.userInfo.currentRole,
  availableRoles: state => state.userInfo.roles,
  availableGroups: state => state.userInfo.groups,
  availableCarteams: state => state.userInfo.carTeams,
  availableGroupsCarteams: state => state.availableGroupsCarteams,
  availableCompanys: state => state.userInfo.companys,
  isDdyUser: (state) => {
    let roles = state.userInfo.roles || []
    let isDdy = false
    roles.forEach((item) => {
      if (item.name === '调度员') {
        isDdy = true
      }
    })
    return isDdy
  },
  availableSelectGroups: (state) => {
    let data = []
    let groups = state.userInfo && state.userInfo.groups ? state.userInfo.groups : []
    groups.forEach((item) => {
      data.push({
        key: item.id,
        label: item.name
      })
    })
    return data
  },
  availableSelectCompanys: (state) => {
    let data = []
    let companys = state.userInfo && state.userInfo.companys ? state.userInfo.companys : []
    companys.forEach((item) => {
      data.push({
        key: item.id,
        label: item.name
      })
    })
    return data
  },
  availableSelectCarteams: (state) => {
    let data = []
    let carTeams = state.userInfo && state.userInfo.carTeams ? state.userInfo.carTeams : []
    carTeams.forEach((item) => {
      data.push({
        key: item.id,
        label: item.name
      })
    })
    return data
  }
}

const actions = {
  setUserData ({ dispatch, getters }, data) {
    let previlege = data.previlege || []
    let groups = []
    let carTeams = []
    let companys = []
    previlege.forEach((item) => {
      if (item.paramName === 'groupId') {
        groups.push({
          name: item.pName,
          id: item.id
        })
      }
      if (item.paramName === 'carGroupId') {
        carTeams.push({
          name: item.pName,
          id: item.id
        })
      }
      if (item.paramName === 'gasCompanyId') {
        companys.push({
          name: item.pName,
          id: item.id
        })
      }
    })
    let currentPrevilege = previlege && previlege.length > 0 ? previlege[0] : null
    let roles = data.roles || []
    dispatch('setUserInfo', {
      name: data.name,
      id: data.id,
      previlege: previlege,
      currentPrevilege: currentPrevilege,
      roles: roles,
      currentRole: roles && roles.length > 0 ? roles[0] : null,
      companys: companys,
      carTeams: carTeams,
      groups: groups
    })
    dispatch('setAvailableMenus', data.menus)
    let needUpdateStatus = false
    roles.forEach((item) => {
      if (['调度员', '车队', '分公司', '运输车队'].includes(item.name)) {
        needUpdateStatus = true
      }
    })
    if (needUpdateStatus && !getters.isWeiXinUse) {
      dispatch('setNeedYwyUpdateStatus', true)
      dispatch('setNeedPsdUpdateStatus', true)
    }
  },
  setUserInfo ({ commit, dispatch }, data) {
    let currentGroupId = getData('currentGroupId')
    if (currentGroupId && data && data.previlege) {
      data.previlege.forEach((item) => {
        if (item.paramName === 'groupId' && item.id === Number(currentGroupId)) {
          data.currentPrevilege = item
        }
      })
    }
    if (data.currentPrevilege && data.currentPrevilege.paramName === 'groupId' && data.currentPrevilege.id !== getters.currentGroupId) {
      dispatch('loadGroupCarteam')
    }
    commit('setUserInfo', data)
  },
  loadGroupCarteam ({ dispatch, getters }, data) {
    let parm = {
      noPage: 1,
      groupIds: getters.currentGroupId
    }
    groupGetCarteams(parm).then((data) => {
      dispatch('setAvailableGroupsCarteams', data)
    })
  },
  setAvailableGroupsCarteams ({ commit }, data) {
    commit('setAvailableGroupsCarteams', data)
  },
  setCurrentPrevilege ({ dispatch, commit }, data) {
    commit('setCurrentPrevilege', data)
    if (data && data.paramName === 'groupId') {
      dispatch('loadGroupCarteam')
    }
  },
  setAvailableMenus ({ commit, dispatch }, data) {
    commit('setAvailableMenus', data)
    // dispatch('goFirstPage')
  },
  setUserDriverList ({ commit, dispatch }, data) {
    commit('setUserDriverList', data)
  }
}

const mutations = {
  setAvailableGroupsCarteams (state, data) {
    state.availableGroupsCarteams = data
  },
  setCurrentPrevilege (state, data) {
    state.userInfo.currentPrevilege = data
  },
  setUserInfo (state, data) {
    state.userInfo = data
  },
  setAvailableMenus (state, data) {
    state.availableMenus = data
  },
  setUserDriverList (state, data) {
    state.userDriverList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js